<div class="container">
    <div class="eui-u-flex eui-u-flex-column">
        <div class="eu-captcha eui-u-flex eui-u-flex-column eui-u-p-m" [formGroup]="captchaForm">
            <p class="eui-u-text-center">
                {{ "page.support.captcha.textual.instruction" | translate }}
            </p>

            <img
                [src]="captchaImage()"
                [attr.alt]="'page.support.captcha.textual.imageAlt' | translate"
                width="200"
                id="captchaImage"
            />

            <button euiButton class="eui-u-m-l" euiVariant="primary" (click)="onRefresh()">
                {{ "page.support.captcha.textual.refresh" | translate }}
            </button>

            <audio
                controls
                autostart="1"
                [src]="audioCaptcha"
                id="audioCaptcha"
                (play)="onPlayAudio()"
            ></audio>

            <div euiInputGroup>
                <label for="captchaAnswer">{{
                    "page.support.captcha.textual.answer" | translate
                }}</label>
                <input
                    id="captchaAnswer"
                    euiInputText
                    type="text"
                    formControlName="answer"
                    [attr.placeholder]="'page.support.captcha.textual.typeCaptcha' | translate"
                />
            </div>
        </div>
    </div>
    <div class="captcha-status">
        @if (showAlert()) {
            <eui-feedback-message euiDanger>
                <span>{{ alertMessage }}</span>
            </eui-feedback-message>
        }
    </div>
</div>
